import * as vueMounter from "@scripts/vueMounter.ts";
import { commonComponents } from "@scripts/public/common.ts";
import ContactForm from "@components/partials/public/contacts/ContactForm.vue";

const pageComponents = {
  ContactForm
};

const components = Object.assign(pageComponents, commonComponents);

vueMounter.mount(components);
